export default __webpack_public_path__ + "static/media/why6.3431a77d.png";